module.exports = __webpack_public_path__ + "img/lich_hoc.5db1f41a.svg";